import LoadingRow from "@/components/LoadingRow";
import usePostRetryTranscript from "@/hooks/mutations/usePostRetryTranscript";
import { Recording } from "@/models/recording";
import {
  ButtonSize,
  Color,
  HorizontalFlex,
  IconButton,
  IconSize,
  InformationFilledIcon,
  RefreshIcon,
  Space,
  Tooltip,
  VerticalFlex,
} from "@enxcs/dap-ui-stratos";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { RecordingTableRowActions } from "../RecordingTable/RecordingTableRowActions";

type FailActionsProps = {
  record: Recording;
};

const FailActions: FC<FailActionsProps> = ({ record }) => {
  const { t } = useTranslation();

  const { isPending, mutate } = usePostRetryTranscript();

  const handleRetryTranscript = () => {
    mutate({ recordingId: record.recordingId });
  };

  return (
    <HorizontalFlex $justify="flex-end" $padRight={"36px" as Space} $gap={Space.V4}>
      <Tooltip content={t("failMessage.retry")}>
        <HorizontalFlex $pad={Space.V8}>
          <InformationFilledIcon size={IconSize.V16} tone={Color.Teal.V30} />
        </HorizontalFlex>
      </Tooltip>

      {isPending ? (
        <VerticalFlex style={{ padding: "0 10px" }}>
          <LoadingRow />
        </VerticalFlex>
      ) : (
        <IconButton disabled={isPending} icon={RefreshIcon} title={t("buttons.refresh")} size={ButtonSize.S} onClick={handleRetryTranscript} />
      )}

      <RecordingTableRowActions record={record} />
    </HorizontalFlex>
  );
};

export default FailActions;
